/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Change_Field_Proposed_SkuInputs */

const en_po_change_field_proposed_sku = /** @type {(inputs: Po_Change_Field_Proposed_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposed SKU`)
};

/**
* | output |
* | --- |
* | "Proposed SKU" |
*
* @param {Po_Change_Field_Proposed_SkuInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_change_field_proposed_sku = /** @type {((inputs?: Po_Change_Field_Proposed_SkuInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Change_Field_Proposed_SkuInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_change_field_proposed_sku(inputs)
});